export default __webpack_public_path__ + "static/1-6abcc269436dd93238970ea488a92fa9.jpg";